module.exports = __webpack_public_path__ + "img/white_grey_oak.fed90179.jpg";